import { useAppSelector } from 'app/config/store';

export const getInvalidTabs = () => {
  const validationErrors = useAppSelector(state => state.validationErrors);

  return validationErrors?.tabValidationErrors.length > 0 ? validationErrors?.tabValidationErrors.map(tab => tab.tabKey) : [];
};

export const getInvalidRowsForTable = (tableQueryKey: string) => {
  const validationErrors = useAppSelector(state => state.validationErrors);

  if (validationErrors && validationErrors.tabValidationErrors && validationErrors.tabValidationErrors.length > 0) {
    const validationTables = validationErrors.tabValidationErrors
      .flatMap(tabError => tabError.tableValidationErrors)
      .filter(tableError => tableError?.tableQueryKey === tableQueryKey);

    return validationTables.length > 0 ? validationTables[0].nonValidRowIds : [];
  }

  return [];
};

export const getInvalidCaseActs = () => {
  const validationErrors = useAppSelector(state => state.validationErrors);

  return validationErrors.actValidationErrors?.length > 0 ? validationErrors.actValidationErrors : [];
};
